import { NgModule } from '@angular/core';
import {
  AutoRefreshTokenService,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  UserActivityService,
  createInterceptorCondition,
  provideKeycloak,
  withAutoRefreshToken,
} from 'keycloak-angular';
import { environment } from '../../environments/environment';

/**
 * O bearer token só é anexado às chamadas para a própria API (ORDS/Go) -
 * mantém o comportamento equivalente ao antigo `bearerExcludedUrls`, que excluía
 * a URL do Oracle Object Storage.
 */
function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const apiOrigins = [environment.API_ORDS_BASE_PATH, environment.API_GO_BASE_PATH].map(url => escapeRegExp(new URL(url).origin));

const bearerTokenCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`^(${apiOrigins.join('|')})`),
});

@NgModule({
  providers: [
    provideKeycloak({
      config: {
        url: environment.KeycloakUrl,
        realm: environment.KeycloakRealm,
        clientId: environment.KeycloakClientId,
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
      },
      // O logout por inatividade é do InatividadeService; o sessionTimeout igual ao dele mantém a sessão do
      // Keycloak renovada enquanto o timer do front não vence.
      features: [withAutoRefreshToken({ onInactivityTimeout: 'none', sessionTimeout: environment.inatividade.logoutMs })],
      // AutoRefreshTokenService/UserActivityService não são providedIn: 'root' nesta versão do keycloak-angular.
      providers: [AutoRefreshTokenService, UserActivityService],
    }),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [bearerTokenCondition],
    },
  ],
})
export class AppAuthModule {}
